import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface LoyaltyProgram {
  id: string;
  name: string;
  nameAr: string;
  logo: string;
  color: string;
}
interface LoyaltyProgramModalProps {
  isOpen: boolean;
  onClose: () => void;
  program: LoyaltyProgram;
  onPointsApplied: (program: string, amount: number) => void;
}
export function LoyaltyProgramModal({
  isOpen,
  onClose,
  program,
  onPointsApplied
}: LoyaltyProgramModalProps) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [selectedMethod, setSelectedMethod] = useState<'phone' | 'account'>('phone');
  const [step, setStep] = useState<'input' | 'verify'>('input');
  const [verificationCode, setVerificationCode] = useState('');
  const [availablePoints, setAvailablePoints] = useState(0);
  const [pointsToUse, setPointsToUse] = useState('');
  if (!isOpen) return null;
  const handleSendCode = () => {
    setAvailablePoints(5000);
    setStep('verify');
  };
  const handleApplyPoints = () => {
    const points = parseFloat(pointsToUse);
    if (points > 0 && points <= availablePoints) {
      onPointsApplied(program.id, points);
      onClose();
    }
  };
  const getInstructions = () => {
    switch (program.id) {
      case 'qitaf':
        return 'Enter Qitaf registered mobile number';
      case 'tamayouz':
        return 'Please enter STC Tamayouz phone number';
      case 'mokafaa':
        return 'Enter your phone number or your account number to redeem your points';
      default:
        return 'Enter your details to use points';
    }
  };
  const isInputValid = () => {
    if (program.id === 'mokafaa' || program.id === 'tamayouz') {
      return phoneNumber.trim() !== '';
    }
    return selectedMethod === 'phone' ? phoneNumber.trim() !== '' : accountNumber.trim() !== '';
  };
  return <>
      {/* Desktop Modal */}
      <div className="hidden md:block fixed inset-0 z-[60] overflow-y-auto" data-id="element-1835" data-mp="13fc685dyipu1">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} data-id="element-1836" data-mp="361hkgxs2jb2q"></div>
        <div className="flex min-h-full items-center justify-center p-4" data-id="element-1837" data-mp="319q2vcqw4foq">
          <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-1838" data-mp="2wbeqovd4ht3c">
            <div className="flex items-center justify-between mb-4" data-id="element-1839" data-mp="2rclfxap80g6v">
              <h2 className="text-xl font-bold" data-id="element-1840" data-mp="2reelsns0ewdt">
                Use Points - {program.nameAr}
              </h2>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-1841" data-mp="3oxzk01d5sf9j">
                <XIcon className="w-6 h-6" data-id="element-1842" data-mp="3f1moqz1yttco" />
              </button>
            </div>
            {step === 'input' ? <>
                <p className="text-sm text-gray-600 mb-4" data-id="element-1843" data-mp="3b014utr0kesz">
                  {getInstructions()}
                </p>
                <div className="mb-4" data-id="element-1844" data-mp="23kwgzbhw8tgy">
                  <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden focus-within:border-[#1E2B55] focus-within:ring-1 focus-within:ring-[#1E2B55] transition-all" data-id="element-1845" data-mp="1zkw1romz0e8u">
                    <select value={selectedMethod} onChange={e => setSelectedMethod(e.target.value as 'phone' | 'account')} className="bg-gray-50 px-3 py-3 border-r border-gray-300 text-sm font-medium focus:outline-none cursor-pointer" data-id="element-1846" data-mp="j4gl33v577mi">
                      <option value="phone" data-id="element-1847" data-mp="xt2wiuhnff8g">+966</option>
                      <option value="account" data-id="element-1848" data-mp="12spbb8d4l3jd">Account</option>
                    </select>
                    <input type={selectedMethod === 'phone' ? 'tel' : 'text'} value={selectedMethod === 'phone' ? phoneNumber : accountNumber} onChange={e => {
                  if (selectedMethod === 'phone') {
                    setPhoneNumber(e.target.value);
                  } else {
                    setAccountNumber(e.target.value);
                  }
                }} placeholder={selectedMethod === 'phone' ? '530151938' : 'Enter account number'} className="flex-1 px-3 py-3 focus:outline-none text-sm" data-id="element-1849" data-mp="16uj8h6o43pes" />
                  </div>
                </div>
                <button onClick={handleSendCode} disabled={!isInputValid()} className="w-full bg-[#1E2B55] text-white py-3 rounded-lg font-medium hover:bg-[#162041] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-1850" data-mp="2n9ng0470hfwa">
                  {program.id === 'mokafaa' ? 'Send code' : 'Next'}
                </button>
              </> : <>
                <div className="mb-4" data-id="element-1851" data-mp="24hchemje443z">
                  <p className="text-sm text-gray-600 mb-2" data-id="element-1852" data-mp="1gtbg9yojjpyl">
                    Available Points:{' '}
                    <span className="font-bold text-[#1E2B55]" data-id="element-1853" data-mp="1bvjkuuootlpn">
                      {availablePoints.toLocaleString()}
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mb-4" data-id="element-1854" data-mp="3s8ts46bnw0zp">1 Point = 1 SAR</p>
                </div>
                <div className="mb-4" data-id="element-1855" data-mp="3djxn6i4wj43b">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1856" data-mp="3dkywah2cxgie">
                    Enter Verification Code
                  </label>
                  <input type="text" value={verificationCode} onChange={e => setVerificationCode(e.target.value)} placeholder="Enter code" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1857" data-mp="a37axliq7ut6" />
                </div>
                <div className="mb-4" data-id="element-1858" data-mp="55yo37mmv2ll">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1859" data-mp="2lroqpe93abqq">
                    Points to Use
                  </label>
                  <input type="number" value={pointsToUse} onChange={e => setPointsToUse(e.target.value)} placeholder="0" max={availablePoints} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1860" data-mp="2ps8omk1hljdx" />
                  <button onClick={() => setPointsToUse(availablePoints.toString())} className="text-xs text-[#1E2B55] hover:underline mt-1" data-id="element-1861" data-mp="hknbptx26z7l">
                    Use all points
                  </button>
                </div>
                <button onClick={handleApplyPoints} disabled={!verificationCode || !pointsToUse} className="w-full bg-[#1E2B55] text-white py-3 rounded-lg font-medium hover:bg-[#162041] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-1862" data-mp="3n75aierj5fu">
                  Apply Points
                </button>
              </>}
          </div>
        </div>
      </div>
      {/* Mobile Bottom Sheet */}
      <div className="md:hidden fixed inset-0 z-[60]" data-id="element-1863" data-mp="25j66mnu2u39n">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} data-id="element-1864" data-mp="2abh9nzk4656f"></div>
        <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-xl max-h-[90vh] overflow-y-auto" data-id="element-1865" data-mp="2f991ktkrdram">
          <div className="p-4" data-id="element-1866" data-mp="1ilma7a2jkz41">
            <div className="flex items-center justify-between mb-4" data-id="element-1867" data-mp="1mlmwthzsogm6">
              <h2 className="text-lg font-bold" data-id="element-1868" data-mp="1mlwmf4gxglrc">
                Use Points - {program.nameAr}
              </h2>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-1869" data-mp="1rmsnzbdt3vtl">
                <XIcon className="w-6 h-6" data-id="element-1870" data-mp="330efv4b1wbit" />
              </button>
            </div>
            {step === 'input' ? <>
                <p className="text-sm text-gray-600 mb-4" data-id="element-1871" data-mp="37xelje3znc9e">
                  {getInstructions()}
                </p>
                <div className="mb-4" data-id="element-1872" data-mp="3t0xj55njnbj2">
                  <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden focus-within:border-[#1E2B55] focus-within:ring-1 focus-within:ring-[#1E2B55] transition-all" data-id="element-1873" data-mp="3p1yfrphgnmtq">
                    <select value={selectedMethod} onChange={e => setSelectedMethod(e.target.value as 'phone' | 'account')} className="bg-gray-50 px-3 py-3 border-r border-gray-300 text-sm font-medium focus:outline-none cursor-pointer" data-id="element-1874" data-mp="1w77yltwl5j9">
                      <option value="phone" data-id="element-1875" data-mp="pl070r5tnti3">+966</option>
                      <option value="account" data-id="element-1876" data-mp="kn6z9toverfp">Account</option>
                    </select>
                    <input type={selectedMethod === 'phone' ? 'tel' : 'text'} value={selectedMethod === 'phone' ? phoneNumber : accountNumber} onChange={e => {
                  if (selectedMethod === 'phone') {
                    setPhoneNumber(e.target.value);
                  } else {
                    setAccountNumber(e.target.value);
                  }
                }} placeholder={selectedMethod === 'phone' ? '530151938' : 'Enter account number'} className="flex-1 px-3 py-3 focus:outline-none text-sm" data-id="element-1877" data-mp="2rdodd9drix23" />
                  </div>
                </div>
                <button onClick={handleSendCode} disabled={!isInputValid()} className="w-full bg-[#1E2B55] text-white py-3 rounded-lg font-medium active:bg-[#162041] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-1878" data-mp="o5e9t77dgg3b">
                  {program.id === 'mokafaa' ? 'Send code' : 'Next'}
                </button>
              </> : <>
                <div className="mb-4" data-id="element-1879" data-mp="28ivbp1mfqkqz">
                  <p className="text-sm text-gray-600 mb-2" data-id="element-1880" data-mp="2u9bn36t5u2jt">
                    Available Points:{' '}
                    <span className="font-bold text-[#1E2B55]" data-id="element-1881" data-mp="2z0tofvz3i55b">
                      {availablePoints.toLocaleString()}
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mb-4" data-id="element-1882" data-mp="2paqmh69zxguu">1 Point = 1 SAR</p>
                </div>
                <div className="mb-4" data-id="element-1883" data-mp="3d0bh4mfii2jy">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1884" data-mp="3d1cwh33k9b7h">
                    Enter Verification Code
                  </label>
                  <input type="text" value={verificationCode} onChange={e => setVerificationCode(e.target.value)} placeholder="Enter code" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1885" data-mp="3hx1uv33ugm27" />
                </div>
                <div className="mb-4" data-id="element-1886" data-mp="1wjqj8xjhoh48">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1887" data-mp="1p1r5lmud5ein">
                    Points to Use
                  </label>
                  <input type="number" value={pointsToUse} onChange={e => setPointsToUse(e.target.value)} placeholder="0" max={availablePoints} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-1888" data-mp="1k5k17yhm8b2t" />
                  <button onClick={() => setPointsToUse(availablePoints.toString())} className="text-xs text-[#1E2B55] active:underline mt-1" data-id="element-1889" data-mp="11avaogum2376">
                    Use all points
                  </button>
                </div>
                <button onClick={handleApplyPoints} disabled={!verificationCode || !pointsToUse} className="w-full bg-[#1E2B55] text-white py-3 rounded-lg font-medium active:bg-[#162041] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-1890" data-mp="njqh9whu675a">
                  Apply Points
                </button>
              </>}
          </div>
        </div>
      </div>
    </>;
}